import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map, shareReplay } from "rxjs/operators";
import { NsWISConfigurations } from "../models/configurations.model";
import { EmpUserService } from "./emp-user.service";
@Injectable({
  providedIn: "root"
})
export class WisConfigService {
  serviceHosts = this.getHostUrls().pipe(shareReplay());

  constructor(private http: HttpClient, private userSvc: EmpUserService) {}

  private getHostUrls(): Observable<NsWISConfigurations.IHostUrls> {
    return this.http
      .get<NsWISConfigurations.IHostUrls>(`${this.userSvc.environment.empExp}/${this.userSvc.employeeInfo.buid}/configurations/service-hosts`)
      .pipe(
        map(res => {
          return {
            empExpUi: res.empExpUi || this.userSvc.environment.empExpUI,
            empExpStatic: res.empExp || this.userSvc.environment.empExpStatic,
            empExp: res.empExp || this.userSvc.environment.empExp,
            floorManagementUrl: res.floorManagement
          } as unknown as NsWISConfigurations.IHostUrls;
        })
      );
  }
}
